import { QuoteFormPostRequestBody, QuoteFormRequestParams, QuoteFormSearchResponse } from '@lio/api-types';
import { formVersionQueryKeys } from '@services/formVersion/keys';
import { quoteFormQueryKeys } from '@services/quoteForm/keys';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

type CreateQuoteFormParams = QuoteFormPostRequestBody &
  QuoteFormRequestParams & {
    /** Force form override (SystemAdmin only) — available after api-types republish */
    forceForm?: boolean;
  };

export const useCreateQuoteForm = () => {
  const client = useClient();
  const queryClient = useQueryClient();

  const result = useMutation({
    mutationFn: async ({ quoteId, formVersionId, instanceNumber, forceForm }: CreateQuoteFormParams) => {
      return client
        .post(`quote/${quoteId}/quote-form`, {
          json: {
            formVersionId,
            instanceNumber,
            ...(forceForm !== undefined && { forceForm }),
          },
        })
        .json<QuoteFormSearchResponse['items'][number]>();
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['quote', { quoteId: variables.quoteId }],
      });
      queryClient.invalidateQueries({
        queryKey: quoteFormQueryKeys.searchWithParams({ quoteId: variables.quoteId }),
      });
      queryClient.invalidateQueries({
        queryKey: formVersionQueryKeys.get(variables.quoteId),
      });
    },
  });

  return { ...result, createQuoteForm: result.mutate, createQuoteFormAsync: result.mutateAsync };
};
